// extracted by mini-css-extract-plugin
module.exports = {"payment":"EmployeeBonusForm__payment--1dUhG","paymentClm":"EmployeeBonusForm__paymentClm--3nG0O","noMemo":"EmployeeBonusForm__noMemo--2hAPg"};